// Definição para o modal de busca de Contabilistas (registro 0100 do SPED).
// Utilizada na geração do SPED para selecionar o contabilista responsável.

export const criarConfigBuscaContabilista = () => ({
  label: 'Contabilista',
  placeholder: 'Nome ou CRC...',
  titulo: 'Selecionar Contabilista',
  endpointApi: 'Contabilistas',
  idField: 'idContabilista',
  displayField: 'nome',
  descField: 'nome',
  tabela: 'Contabilista',
  camposFiltro: [
    { label: 'Nome', model: 'busca', tipo: 'text' }
  ],
  colunasGrid: [
    { header: 'ID', dataField: 'idContabilista', width: '10%' },
    { header: 'Nome', dataField: 'nome', width: '50%' },
    { header: 'CRC', dataField: 'crcNumero', width: '20%' },
    { header: 'Status', dataField: 'lstStatus', width: '20%' }
  ]
})
